import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ReportTabs from './ReportTabs';
import ReportTypeSelector from './ReportTypeSelector';
import { getReportData } from '../../data/sampleReportData';
import { getReportTypeById } from '../../types/reportTypes';

interface InteractiveReportProps {
  sampleDataUrl?: string;
  initialTab?: string;
  initialReportType?: string;
}

const InteractiveReport: React.FC<InteractiveReportProps> = ({ 
  initialTab = 'summary',
  initialReportType = 'uti_ud_112'
}) => {
  const [selectedReportType, setSelectedReportType] = useState(initialReportType);
  const reportData = getReportData(selectedReportType);
  const reportType = getReportTypeById(selectedReportType);

  const handleReportTypeChange = (reportTypeId: string) => {
    setSelectedReportType(reportTypeId);
  };

  const handleViewPDF = () => {
    if (reportType?.pdfPath) {
      window.open(reportType.pdfPath, '_blank');
    }
  };
  
  return (
    <motion.div 
      className="bg-section-light p-8 rounded-lg shadow-md flex flex-col items-center" 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <ReportTypeSelector 
        selectedReportType={selectedReportType}
        onReportTypeChange={handleReportTypeChange}
      />

      <div className="flex flex-row justify-between items-center w-full mb-6">
        <h2 className="text-2xl font-bold text-text">Interactive Web Report Interface Demo</h2>
        <div className="flex gap-3">
          <button 
            onClick={handleViewPDF}
            className="btn btn-secondary bg-secondary text-white rounded-lg px-4 py-2 hover:bg-secondary/90 transition-colors"
          >
            View PDF Report
          </button>
          <a href="/report" className="btn btn-secondary bg-primary text-white rounded-lg px-4 py-2">View PDF Demo Page</a>
        </div>
      </div>
      
      <ReportTabs reportData={reportData} initialTab={initialTab} />
      
      <div className="text-center mt-6">
        <button className="btn btn-primary">View Full Report</button>
      </div>
      
    </motion.div>
  );
};

export default InteractiveReport; 